<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <asignatura-agregar-form @success="success"></asignatura-agregar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <asignatura-agregar-form @success="success"></asignatura-agregar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'asignatura-agregar-form': require('./AsignaturaAgregarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
